import { Cell } from '@table-library/react-table-library/table';
import moment from 'moment';
import PromptsModal from './modal';

export const COLUMNS = (t) => [
    {
        label: t('ai_tracking.prompt_history.table.project'),
        key: 'project',
        data: 'project',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data }) => data?.name || '-',
    },
    {
        label: (
            <div className="ai-tracking-country-language">
                <div className="ai-tracking-country-language-country">
                    {t('ai_tracking.prompt_history.table.brand_name')}
                </div>
                <div className="ai-tracking-country-language-lan">
                    {t('ai_tracking.prompt_history.table.brand_domain')}
                </div>
            </div>
        ),
        key: 'brand_domain',
        data: 'brand_domain',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.project?.own_domain;
            return (
                <div className="ai-tracking-country-language">
                    <div className="ai-tracking-country-language-country">
                        {item.project?.own_product_name || '-'}
                    </div>
                    <div className="ai-tracking-country-language-lan">
                        {item.project?.own_domain || '-'}
                    </div>
                </div>
            );
        },
    },
    // {
    //     label: t('ai_tracking.prompt_history.table.country_language'),
    //     key: 'country_language',
    //     data: 'country_language',
    //     Component: Cell,
    //     renderCell: ({ item }) => `${item.country} - ${item.language}`,
    //     sortType: (array) =>
    //         array.sort((a, b) =>
    //             `${a.country} - ${a.language}`.localeCompare(`${b.country} - ${b.language}`),
    //         ),
    // },
    {
        label: t('ai_tracking.prompt_history.table.modified_at'),
        key: 'modified_at',
        data: 'modified_at',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data }) => (data ? moment(data).format('YYYY-MM-DD HH:mm') : '-'),
    },
    {
        label: t('ai_tracking.prompt_history.table.status'),
        key: 'status',
        data: 'status',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data }) => data?.replace(/_/g, ' '),
    },
    {
        label: t('ai_tracking.prompt_history.table.expand_urls'),
        key: 'expand_urls',
        data: 'expand_urls',
        Component: Cell,
        renderCell: ({ item, csvDownload }) =>
            !csvDownload ? <PromptsModal items={item} additionalClass="grid-1" /> : item?.topics,
    },
];
